import { useEffect } from "react";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import { _zzyourmap_routing_browser_title_update } from "../utils/zz/zz-yourmap-routing";


// STATIC PAGES

const YourmapSectionStaticPageStuffONama = (props) => {
  const title = 'O nama';
  _zzyourmap_routing_browser_title_update(title);
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle"><div className="uu-gap-standalone-1rem"></div><h2>{title}</h2><p className="uu-display-none"></p><div className="uu-display-none uu-gap-standalone-8px"></div></div>

          {/* Hero intro */}
          <div style={{ background: 'linear-gradient(135deg, #eff6ff 0%, #f0fdf4 100%)', border: '1px solid #e5e7eb', borderLeft: '4px solid #2563EB', borderRadius: '10px', padding: '1.75rem 1.5rem', marginBottom: '2.5rem' }}>
            <p style={{ margin: 0, fontSize: '1.08rem', lineHeight: '1.7', color: '#333' }}>
              <strong style={{ color: '#2563EB' }}>Yourmap</strong> je vaš pouzdani vodič kroz najlepše destinacije Srbije. Nastali iz ljubavi prema putovanjima i lepotama naše zemlje, pomažemo vam da pronađete savršeno mesto za odmor — bez dugog pretražavanja i nepotrebnog gubljenja vremena.
            </p>
          </div>

          {/* What is Yourmap */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '1.05rem', color: '#111', marginBottom: '0.75rem' }}>
              <span style={{ width: '2rem', height: '2rem', borderRadius: '50%', background: '#eff6ff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.85rem', flexShrink: 0 }}>
                <i className="fa fa-map-marker" aria-hidden="true"></i>
              </span>
              Šta je Yourmap?
            </h3>
            <p style={{ color: '#555', lineHeight: '1.7', margin: 0 }}>
              Yourmap je platforma koja na jednom mestu okuplja informacije o turističkim destinacijama, smeštajima i sadržajima širom Srbije. Bilo da planirate vikend na <strong>Zlatiboru</strong>, odmor na <strong>Kopaoniku</strong> ili avanturu u <strong>Bajnoj Bašti</strong> — kod nas ćete naći sve što vam treba za pravo iskustvo.
            </p>
          </div>

          {/* Mission */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '1.05rem', color: '#111', marginBottom: '0.75rem' }}>
              <span style={{ width: '2rem', height: '2rem', borderRadius: '50%', background: '#eff6ff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.85rem', flexShrink: 0 }}>
                <i className="fa fa-heart" aria-hidden="true"></i>
              </span>
              Naša misija
            </h3>
            <p style={{ color: '#555', lineHeight: '1.7', margin: 0 }}>
              Verujemo da svako zaslužuje lako i prijatno planiranje odmora. Naša misija je da turistima pružimo jasne, tačne i korisne informacije, a domaćinima i pružaocima usluga — prostor da budu vidljivi pravim gostima. Bez komplikacija, bez žargona.
            </p>
          </div>

          {/* Value props - feature cards */}
          <div style={{ marginBottom: '2.5rem' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '1.05rem', color: '#111', marginBottom: '1rem' }}>
              <span style={{ width: '2rem', height: '2rem', borderRadius: '50%', background: '#eff6ff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.85rem', flexShrink: 0 }}>
                <i className="fa fa-star" aria-hidden="true"></i>
              </span>
              Zašto Yourmap?
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              {[
                { icon: 'fa-check-circle', title: 'Proverene destinacije', desc: 'Fokusiramo se na mesta koja stvarno vredi posetiti.' },
                { icon: 'fa-bed', title: 'Pregled smeštaja', desc: 'Lako pronađite apartmane, kuće i hotele na izabranoj lokaciji.' },
                { icon: 'fa-mobile', title: 'Jednostavno korišćenje', desc: 'Intuitivno sučelje koje radi podjednako dobro na telefonu i računaru.' },
                { icon: 'fa-flag', title: 'Lokalna perspektiva', desc: 'Sadržaj koji razume srpski turizam iznutra.' },
              ].map((item) => (
                <div key={item.title} style={{ flex: '1 1 200px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '1.25rem 1.25rem 1.1rem', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem', marginBottom: '0.5rem' }}>
                    <span style={{ width: '1.75rem', height: '1.75rem', borderRadius: '50%', background: '#eff6ff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.8rem', flexShrink: 0 }}>
                      <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                    </span>
                    <strong style={{ fontSize: '0.88rem', color: '#111' }}>{item.title}</strong>
                  </div>
                  <p style={{ margin: 0, fontSize: '0.83rem', color: '#666', lineHeight: '1.55' }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA closing block */}
          <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <p style={{ margin: '0 0 0.25rem', fontWeight: 700, color: '#111', fontSize: '0.95rem' }}>Za vas smo tu</p>
              <p style={{ margin: 0, fontSize: '0.88rem', color: '#666' }}>
                Yourmap kontinuirano raste. Vaše iskustvo je ono što nas pokreće napred.
              </p>
            </div>
            <a href="/kontakt" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: '#2563EB', color: '#fff', padding: '0.55rem 1.25rem', borderRadius: '6px', textDecoration: 'none', fontWeight: 600, fontSize: '0.88rem', whiteSpace: 'nowrap' }}>
              <i className="fa fa-envelope-o" aria-hidden="true"></i> Kontaktirajte nas
            </a>
          </div>

        </div>
      </section>
    </>
  );
};
//
const YourmapSectionStaticPageStuffKontakt = (props) => {
  const title = 'Kontakt';
  _zzyourmap_routing_browser_title_update(title);
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle"><div className="uu-gap-standalone-1rem"></div><h2>{title}</h2><p className="uu-display-none"></p><div className="uu-display-none uu-gap-standalone-8px"></div></div>

          <p style={{ fontSize: '1.05rem', color: '#444', marginBottom: '2rem' }}>
            Imate pitanje, sugestiju ili predlog? Slobodno nam se javite — tu smo i odgovorićemo što je pre moguće.
          </p>

          {/* Contact cards grid */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginBottom: '2.5rem' }}>

            <div style={{ flex: '1 1 220px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', marginBottom: '0.75rem' }}>
                <span style={{ width: '2rem', height: '2rem', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.85rem' }}>
                  <i className="fa fa-envelope-o" aria-hidden="true"></i>
                </span>
                <strong style={{ fontSize: '0.9rem', color: '#111' }}>E-mail</strong>
              </div>
              <a href="mailto:kontakt@yourmap.rs" style={{ color: '#2563EB', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem' }}>kontakt@yourmap.rs</a>
              <p style={{ margin: '0.4rem 0 0', fontSize: '0.82rem', color: '#888' }}>Odgovaramo u roku od jednog radnog dana.</p>
            </div>

            <div style={{ flex: '1 1 220px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', marginBottom: '0.75rem' }}>
                <span style={{ width: '2rem', height: '2rem', borderRadius: '50%', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563EB', fontSize: '0.85rem' }}>
                  <i className="fa fa-phone" aria-hidden="true"></i>
                </span>
                <strong style={{ fontSize: '0.9rem', color: '#111' }}>Telefon</strong>
              </div>
              <a href="tel:+381694281388" style={{ color: '#2563EB', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem' }}>+381 69 428 1388</a>
              <p style={{ margin: '0.4rem 0 0', fontSize: '0.82rem', color: '#888' }}>Radnim danima od 09 do 17h.</p>
            </div>

          </div>

          {/* Business / partnerships */}
          <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderLeft: '4px solid #2563EB', borderRadius: '8px', padding: '1.5rem', marginBottom: '2.5rem' }}>
            <h3 style={{ marginTop: 0, marginBottom: '0.5rem', fontSize: '1rem', color: '#111' }}>
              <i className="fa fa-handshake-o" aria-hidden="true" style={{ marginRight: '0.5rem', color: '#2563EB' }}></i>
              Poslovna saradnja i partnerstvo
            </h3>
            <p style={{ margin: '0 0 0.75rem', color: '#555', fontSize: '0.92rem' }}>
              Vlasnik ste smeštaja, turističke agencije ili pružate usluge na nekom od naših destinacija? Javite nam se — rado ćemo razgovarati o tome kako da zajedno dođemo do pravih gostiju.
            </p>
            <a href="mailto:saradnja@yourmap.rs" style={{ color: '#2563EB', fontWeight: 600, textDecoration: 'none', fontSize: '0.92rem' }}>
              <i className="fa fa-envelope-o" aria-hidden="true" style={{ marginRight: '0.4rem' }}></i>
              saradnja@yourmap.rs
            </a>
          </div>

          {/* Social */}
          <div>
            <h3 style={{ marginTop: 0, marginBottom: '0.5rem', fontSize: '1rem', color: '#111' }}>Pratite nas</h3>
            <p style={{ color: '#555', fontSize: '0.92rem', marginBottom: '1rem' }}>
              Budite u toku sa novim destinacijama, preporukama i pričama iz srpskog turizma.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              <a href="https://www.instagram.com/yourmap.rs" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1rem', border: '1px solid #e5e7eb', borderRadius: '6px', textDecoration: 'none', color: '#333', fontWeight: 600, fontSize: '0.88rem', background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <i className="fa fa-instagram" aria-hidden="true"></i> Instagram
              </a>
              <a href="https://www.facebook.com/yourmap.rs" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.5rem 1rem', border: '1px solid #e5e7eb', borderRadius: '6px', textDecoration: 'none', color: '#333', fontWeight: 600, fontSize: '0.88rem', background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                <i className="fa fa-facebook" aria-hidden="true"></i> Facebook
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};
//
const YourmapSectionStaticPageStuffUslovi = (props) => {
  const title = 'Uslovi';
  _zzyourmap_routing_browser_title_update(title);
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle"><div className="uu-gap-standalone-1rem"></div><h2>{title}</h2><p className="uu-display-none"></p><div className="uu-display-none uu-gap-standalone-8px"></div></div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
      </section>
    </>
  );
};
//
const YourmapSectionStaticPageStuffPrivatnost = (props) => {
  const title = 'Politika privatnosti';
  _zzyourmap_routing_browser_title_update(title);
  return (
    <>
      <section className="yourmap__section">
        <div className="inner">
          <div className="yourmap__article__title-and-subtitle"><div className="uu-gap-standalone-1rem"></div><h2>{title}</h2><p className="uu-display-none"></p><div className="uu-display-none uu-gap-standalone-8px"></div></div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
      </section>
    </>
  );
};


// DEFAULT COMPONENT
const YourmapSectionStaticPageStuff = (props) => {
  const {
    route_static_page,
  } = props.appPack;
  let jsx = null;
  let title = '';
  if (route_static_page === 'o-nama') {
    title = 'O nama';
    jsx = (
      <YourmapSectionStaticPageStuffONama />
    );
  } else if (route_static_page === 'kontakt') {
    title = 'Kontakt';
    jsx = (
      <YourmapSectionStaticPageStuffKontakt />
    );
  } else if (route_static_page === 'uslovi') {
    title = 'Uslovi';
    jsx = (
      <YourmapSectionStaticPageStuffUslovi />
    );
  } else if (route_static_page === 'privatnost') {
    title = 'Politika privatnosti';
    jsx = (
      <YourmapSectionStaticPageStuffPrivatnost />
    );
  }
  return (
    <>{jsx}</>
  );
};

export default YourmapSectionStaticPageStuff;
